module.exports = __webpack_public_path__ + "img/p1-2.7b827ae3.png";